import { differenceInDays, differenceInHours, format, formatDistanceStrict, } from 'date-fns';
export const formatHowLongAgo = (date) => {
    const now = new Date();
    const diffHours = differenceInHours(now, date);
    if (diffHours < 24) {
        // "x hours ago"
        return `${formatDistanceStrict(date, now, { addSuffix: true, unit: 'hour' })}`;
    }
    const diffDays = differenceInDays(now, date);
    if (diffDays < 30) {
        // "x days ago"
        return `${formatDistanceStrict(date, now, { addSuffix: true, unit: 'day' })}`;
    }
    return format(date, 'MMM do yyyy');
};
